import AuthorizationForm from './AuthorizationForm';

export default AuthorizationForm;
